import { render, staticRenderFns } from "./WBtnReload.vue?vue&type=template&id=183640a0&scoped=true&"
import script from "./WBtnReload.vue?vue&type=script&lang=js&"
export * from "./WBtnReload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183640a0",
  null
  
)

export default component.exports